/**
 * Renders a stored-uppercase name for friendly display:
 * "JEFFREY" -> "Jeffrey", "DELA CRUZ" -> "Dela Cruz".
 *
 * Profile names are stored uppercase — they're typed that way (see
 * ProfilePage's UPPERCASE_FIELDS) and the printed application form needs
 * caps — which reads as shouting in a greeting.
 *
 * This can't be done with CSS: `text-transform: capitalize` only
 * uppercases each word's first letter and leaves the rest as-is, so
 * "JEFFREY" would stay "JEFFREY". Lowercasing first is the only way.
 *
 * Word boundaries include spaces, hyphens and apostrophes so "ANNE-MARIE"
 * and "O'BRIEN" come out right, and \p{L} covers accented letters (Ñ).
 */
export function toTitleCase(name: string | undefined | null): string {
  if (!name) return '';
  return name.toLowerCase().replace(/(^|[\s'-])(\p{L})/gu, (_, boundary: string, letter: string) => boundary + letter.toUpperCase());
}
